import type { ReceiptTemplate } from '../schema';

export const michaelsTemplate: ReceiptTemplate = {
  id: 'michaels',
  name: 'Michaels Receipt',
  brand: 'MICHAELS',
  description: 'Michaels arts and crafts store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'michaels-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/michaels.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          'STORE #489',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'michaels-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'trans', label: 'Trans:', value: '847291' },
        ],
        column2: [
          { id: 'date', label: '', value: '01/04/2026 2:45PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'michaels-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'CRICUT VINYL PACK', quantity: '1', price: '19.99', sku: '847291034' },
          { id: '2', name: 'YARN SKEINS 3PK', quantity: '2', price: '8.99', sku: '847291035' },
          { id: '3', name: 'PICTURE FRAME 8X10', quantity: '1', price: '14.99', sku: '847291036' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'michaels-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '52.96', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '4.37', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '57.33', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'michaels-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'michaels-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'MICHAELS REWARDS MEMBER\n\nReturns within 60 days\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

